import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
    name: "QuizParticipants",
    components:{Loading},
    data() {
        return {
            isLoading: true,
            fullPage: true,
            loader: "bars",
            dailyParticipantsList:[],
        }
    },
    async created() {
        await this.dailyParticipants();
    },
    methods: {
        async dailyParticipants() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const res = await axios.get(
                    this.$baseUrl +
                    this.$api +
                    this.$version3 +
                    "/quiz/daily-participants",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                //console.log(res)
                if (res.status === 200) {
                    //console.log(res.data.data)
                    this.dailyParticipantsList = res.data.data
                } else {
                    this.$vToastify.error("Could not fetch data!");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
    }
}
